// TYPES
export const INIT_MOBILE_OMNI = 'MOBILE_OMNI/INIT_MOBILE_OMNI';
export const SAVE_SEARCH_PARAMS = 'MOBILE_OMNI/SAVE_SEARCH_PARAMS';

export const SEARCH_MOBILE_OMNI_LIST = 'MOBILE_OMNI/SEARCH_MOBILE_OMNI_LIST';
export const SEARCH_MOBILE_OMNI_LIST_SUCCESS =
  'MOBILE_OMNI/SEARCH_MOBILE_OMNI_LIST_SUCCESS';

export const SEARCH_MOBILE_OMNI = 'MOBILE_OMNI/SEARCH_MOBILE_OMNI';
export const SEARCH_MOBILE_OMNI_SUCCESS =
  'MOBILE_OMNI/SEARCH_MOBILE_OMNI_SUCCESS';

export const INFINITE_SEARCH_MOBILE_OMNI_LIST =
  'MOBILE_OMNI/INFINITE_SEARCH_MOBILE_OMNI_LIST';
export const INFINITE_SEARCH_MOBILE_OMNI_LIST_SUCCESS =
  'MOBILE_OMNI/INFINITE_SEARCH_MOBILE_OMNI_LIST_SUCCESS';

export const SEND_SMS_OMNI = 'MOBILE_OMNI/SEND_SMS_OMNI';

// ACTIONS
export const initMobileOmni = payload => {
  return { type: INIT_MOBILE_OMNI, payload };
};
export const saveSearchParams = payload => {
  return { type: SAVE_SEARCH_PARAMS, payload };
};

export const searchMobileOmniList = payload => {
  return { type: SEARCH_MOBILE_OMNI_LIST, payload };
};

export const infiniteSearchMobileOmniList = payload => {
  return { type: INFINITE_SEARCH_MOBILE_OMNI_LIST, payload };
};
export const infiniteSearchMobileOmniListSuccess = payload => {
  return { type: INFINITE_SEARCH_MOBILE_OMNI_LIST_SUCCESS, payload };
};

export const searchMobileOmni = payload => {
  return { type: SEARCH_MOBILE_OMNI, payload };
};

export const sendSmsOmni = payload => {
  return { type: SEND_SMS_OMNI, payload };
};
